import { Wrench, Loader2 } from 'lucide-react';
import { StaticMetricCardAlt } from '@/components/StaticMetricCardAlt';
import { useMaintenanceInsuranceDue } from '@/hooks/use-asset-management-widgets';
import { Card, CardContent } from '@/components/ui/card';

interface KpiMaintenanceDueProps {
  readonly className?: string;
}

export function KpiMaintenanceDue({ className }: KpiMaintenanceDueProps): React.ReactElement {
  const { data, isLoading } = useMaintenanceInsuranceDue(100);

  const maintenanceCount = data?.items.filter((item) => item.type === 'Maintenance').length ?? 0;
  const overdueCount = data?.items.filter((item) => item.type === 'Maintenance' && item.isOverdue).length ?? 0;

  if (isLoading) {
    return (
      <Card className="overflow-hidden border-0">
        <CardContent className="p-6 h-[148px] flex flex-col items-center justify-center">
          <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
          <span className="text-sm text-muted-foreground mt-2">Loading...</span>
        </CardContent>
      </Card>
    );
  }

  return (
    <StaticMetricCardAlt
      title="Maintenance Due"
      value={maintenanceCount.toString()}
      change={overdueCount > 0 ? `${overdueCount}` : '0'}
      changeLabel={overdueCount > 0 ? 'overdue' : 'all up to date'}
      icon={Wrench}
      variant="info"
    />
  );
}
